// Active spreadsheet cell ring.
//
// Both the border and the offset outline are declared here rather than via Bootstrap's `border`
// /`border-primary` utilities: those are `!important` on the fill token, which Bootstrap keeps
// fixed across colour modes, so the border would stay one colour while the outline followed the
// theme. `--bs-link-color` is re-tinted under `[data-bs-theme=dark]`, so both halves of the ring
// track the theme and stay the same colour as each other. The border width matches the `.border`
// utility the inactive cells use, so switching states does not shift layout.

.activeCell {
  border: var(--bs-border-width) solid var(--bs-link-color);
  outline: 2px solid var(--bs-link-color);
  outline-offset: -2px;
}
